import {skipToken} from '@reduxjs/toolkit/query';

import {isNil, isNotNil} from 'ramda';

import {getSafely, Nullish} from 'shared/web';

import {FALLBACK_LANGUAGE} from '../i18n/fallbackLanguage';
import i18n from '../i18n/i18n';
import {
  useGetApiCountriesQuery,
  useGetMakeModelQuery,
  useGetTrimLevelsQuery,
} from '../store/catalogueApi';
import {usePriceReport} from './usePriceReport';

export function useVehicleTranslatedInfo(
  vehicle:
    | {
        make?: string | Nullish;
        modelFamily?: string | Nullish;
        vehicleType?: string | Nullish;
        trimLevel?: string | Nullish;
      }
    | Nullish
) {
  const {requestData} = usePriceReport();
  const language = i18n?.resolvedLanguage ?? FALLBACK_LANGUAGE;

  const {currentData: data, isLoading} = useGetMakeModelQuery(
    isNil(vehicle) || isNil(vehicle.make) || isNil(vehicle.vehicleType)
      ? skipToken
      : {
          make: vehicle.make,
          vehicleType: vehicle.vehicleType,
          lang: [language],
        }
  );
  const {data: apiCountries, isLoading: isApiCountriesLoading} = useGetApiCountriesQuery({
    format: 'iso3',
  });
  const {data: trimLevels, isLoading: isTrimLevelsLoading} = useGetTrimLevelsQuery(
    isNil(vehicle) || isNil(vehicle.make) || isNil(vehicle.modelFamily)
      ? skipToken
      : {
          modelFamily: vehicle.modelFamily,
          make: vehicle.make,
          country: isNotNil(requestData?.market)
            ? getSafely(apiCountries, requestData.market)
            : undefined,
        }
  );

  const make = data?.[0];
  const vehicleData = {
    make: make?.default_label,
    model: make?.models?.find((item) => item.model === vehicle?.modelFamily)?.default_label ?? '',
    trimLevel: trimLevels?.trim_levels?.find((item) => item.const_key === vehicle?.trimLevel)
      ?.label,
    logoUrl: make?.logo_url_2x,
    whiteLogoUrl: make?.white_logo_url_2x,
    blackLogoUrl: make?.black_logo_url_2x,
  };

  return {
    isLoading: isLoading || isApiCountriesLoading || isTrimLevelsLoading,
    data: isNil(vehicle) ? undefinedVehicleData : vehicleData,
  };
}

const undefinedVehicleData = {
  make: '',
  model: '',
  trimLevel: undefined,
  logoUrl: undefined,
  whiteLogoUrl: undefined,
  blackLogoUrl: undefined,
};
